import Text from "./Text";

export default function ErrorText({children, className=''}) {
     return <Text color="var(--errorColor)" type="6" fontWeight="300" className={`mt-1 ${className}`}>{children}</Text>
}